var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
        'ui-alert',
        _setup.props.outlined && `--outlined`,
    ],style:({
        '--ui-alert-color': _setup.props.color,
        '--ui-alert-bg-color': _setup.props.bgColor,
        '--ui-alert-border-color': _setup.props.borderColor,
    })},[_vm._t("icon",function(){return [_c('ui-icon',{staticClass:"ui-alert__icon"},[_c(_setup.props.icon,{tag:"component"})],1)]}),_c('span',{staticClass:"ui-alert__text"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_setup.props.text)+" ")]})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }